import { AxiosInstance } from 'axios';

abstract class KoddiObjectAPI {
    protected axios: AxiosInstance;

    constructor(axios: AxiosInstance) {
        this.axios = axios;
    }

    abstract async create(...args: any[]): Promise<any>;

    abstract async get(...args: any[]): Promise<any>;

    abstract async delete(...args: any[]): Promise<any>;

    abstract async update(...args: any[]): Promise<any>;
}

export default KoddiObjectAPI;
